const EyeClosed = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="var(--eye-closed-fill)"
      d="M18.735 8.063c1.097 1.03 2.042 2.36 2.836 3.992a1.301 1.301 0 0 1 0 1.134c-2.137 4.41-5.377 6.615-9.72 6.615-1.567 0-2.99-.289-4.27-.865l1.245-1.214c.922.328 1.93.493 3.025.493 3.647 0 6.315-1.802 8.195-5.595-.706-1.423-1.523-2.566-2.46-3.439l1.15-1.12Z"
    />
    <path
      fill="var(--eye-closed-fill)"
      fillRule="evenodd"
      d="m19.172 4.052.963.94a.176.176 0 0 1 .053.124.172.172 0 0 1-.053.125L4.044 20.927a.183.183 0 0 1-.256 0l-.964-.94a.174.174 0 0 1 0-.25l2.39-2.33c-1.202-1.057-2.23-2.463-3.084-4.216a1.3 1.3 0 0 1 0-1.134c2.138-4.41 5.378-6.615 9.72-6.615 1.7 0 3.232.34 4.595 1.018l2.47-2.408A.18.18 0 0 1 19.045 4a.185.185 0 0 1 .128.052ZM11.85 7.028c-3.645 0-6.313 1.802-8.195 5.595.768 1.548 1.667 2.764 2.71 3.662l1.885-1.838a3.793 3.793 0 0 1-.425-2.395A3.842 3.842 0 0 1 8.948 9.88a4.015 4.015 0 0 1 2.227-1.093 4.066 4.066 0 0 1 2.457.414l1.588-1.549c-1.016-.419-2.137-.625-3.37-.625Zm-2.346 4.477a2.42 2.42 0 0 0-.155 1.871l3.183-3.103a2.595 2.595 0 0 0-2.263.357 2.488 2.488 0 0 0-.765.875Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--eye-closed-fill)"
      d="M11.529 15.08a2.608 2.608 0 0 0 1.2-.178c.307-.123.586-.305.821-.534a2.46 2.46 0 0 0 .549-.8 2.412 2.412 0 0 0 .181-1.171l1.194-1.163c.275.7.336 1.462.176 2.195a3.85 3.85 0 0 1-1.078 1.934 4.01 4.01 0 0 1-1.985 1.051 4.075 4.075 0 0 1-2.252-.171l1.194-1.163Z"
    />
  </svg>
)
export { EyeClosed }
